import React, {useEffect, useState} from "react";
import {useAppSelector, useAppDispatch} from 'redux/hooks'
import {Divider} from "primereact/divider";
import {Button} from "primereact/button";
import {TabPanel, TabView} from "primereact/tabview";
import {Dialog} from "primereact/dialog";
import {resetScheduler, setActiveClick, setChangedCompaniesData, setChangedScheduler, setCompanyStateSave, setDialogVisible, setErrorFields} from "redux/actions/actions";
import {createCompanies, deleteCompanies, getCampaignDirectoriesGetTranksPhones, getCampaignId, getNotification, getUsers, updateCompanies} from "redux/api/api";
import CompaniesListDialogGeneralSettings from "components/Campaign/DialogGeneralSettings";
import CompaniesListDialogUsers from "components/Campaign/DialogUsers";
import CompaniesListDialogStartEndFinish from "components/Campaign/DialogStartEndFinish";
import CompaniesListDialogManagement from "components/Campaign/DialogManagement";
import CompaniesListDialogInfo from "components/Campaign/DialogInfo";
import CompaniesListDialogLeads from "components/Campaign/DialogLeads";
import CompaniesListRingCycle from "components/Campaign/DialogRingCycle";
import {ConfirmDialog} from "primereact/confirmdialog";
import {getItem} from "../../../redux/cache/cacheService";
import {codes} from "../../../redux/notificationCodes";
import {ProgressBar} from "primereact/progressbar";
import {validate} from "../../../redux/validator/validator";
import {CALLS_DIALER_TYPE, resolveCallsDialerType} from "../../../types/types";
import {checkPermissions} from "../../../redux/permissions/permissionsUtils";
import {getSkillGroupList} from "../../../redux/api/apiQualificationGroup";
import ACDSettingsTab from "../CampaignDialogACD";
import CampaignDialog_IVM_ACD from "../CampaignDialog_IVM_ACD";
import CampaignDialog_Progressive_advanced_ACD from "../CampaignDialog_Progressive_advanced_ACD";
import CampaignDialogAMD from "../CampaignDialogAMD";
import {useNavigate} from "react-router-dom";

const CompaniesListDialog = (props: any) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const companies = useAppSelector(state => state.CompaniesListReducer)
    const companiesData = useAppSelector(state => state.CompaniesListReducer.companiesData)
    const dialogVisible = useAppSelector(state => state.CompaniesListReducer.dialogVisible)
    const companyStateSave = useAppSelector(state => state.CompaniesListReducer.companyStateSave)
    const archiveTableToggle = useAppSelector(state => state.CompaniesListReducer.archiveTableToggle)
    const changeScheduler = useAppSelector(state => state.CompaniesListReducer.changeScheduler)
    const user = useAppSelector(state => state.UsersReducer.userData);
    const [activeIndex, setActiveIndex] = useState(0)
    const [selectIndex, setSelectIndex] = useState(0)
    const [showDeleteNotification, setShowDeleteNotification] = useState<boolean>(false);
    const [showSaveChangeNotification, setShowSaveChangeNotification] = useState<boolean>(false);
    const [createdSchedule, setCreatedSchedule] = useState<boolean>(false);
    const [visible, setVisible] = useState(false);
    const selectedCompanyId = useAppSelector(state => state.CompaniesListReducer.selectedCompanyId)
    const scheduler = useAppSelector(state => state.CompaniesListReducer?.companiesData?.scheduler)
    const deletionNotification = getItem(codes.cancel)
    const saveChangesNotification = getItem(codes.save_changes)
    const changedCompaniesData = useAppSelector(state => state.CompaniesListReducer.changedCompaniesData)
    const statusDone = companiesData?.campaign?.statusId === 6;
    const progressBar = <ProgressBar mode="indeterminate" style={{height: '2px', maxWidth: '95%'}}></ProgressBar>;
    // @ts-ignore
    const saveChangeMessage = <div>{companies && companies.notificationSaveChanges ? companies.notificationSaveChanges.text : saveChangesNotification ? saveChangesNotification : progressBar}</div>
    // @ts-ignore
    const deletionMessage = <div>{companies && companies.notificationCancel ? companies.notificationCancel.text : deletionNotification ? deletionNotification : progressBar}</div>
    const rolesVision = useAppSelector(state => state.RolesReducer.rolesVision) as unknown as Record<string, string[]>;
    const errorFields = useAppSelector(state => state.CompaniesListReducer.errorFields);
    const skillGroupList = useAppSelector(state => state.QualificationGroupListReducer.skillGroupList);
    // @ts-ignore — QueueListReducer stores audio catalog as allAudioGroup
    const allAudioGroup = useAppSelector(state => state.QueueListReducer.allAudioGroup);
    // @ts-ignore
    const queuesDirectoryQueueAudioType = useAppSelector(state => state.QueueListReducer.queuesDirectoryQueueAudioType);
    const dialerPermissions = checkPermissions(rolesVision, 'Campaigns');
    const jwtToken = useAppSelector(state => state.UsersReducer.userData.jwtToken);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const campaignId = companies?.companiesData?.campaign?.campaignId;

    const {
        create: hasCampaignsCreatePermission,
        update: hasCampaignsUpdatePermission,
        delete: hasCampaignsDeletePermission,
    } = dialerPermissions;

    const campaignPermission = companiesData?.permission;
    const detailsLoading = useAppSelector(state => state.CompaniesListReducer.detailsLoading);

    useEffect(() => {
        if (!dialogVisible) {
            return;
        }
        // Wait until CampaignId finishes so permission flags are from API, not defaults
        if (detailsLoading) {
            return;
        }
        // Editing: wait until campaign payload is present (avoids fetch with default permission)
        if (!companyStateSave && !campaignId) {
            return;
        }
        if (!campaignPermission?.usersIsBlock) {
            dispatch(getUsers(jwtToken?.jwtToken, true));
        }
        if (!campaignPermission?.trunksIsBlock) {
            dispatch(getCampaignDirectoriesGetTranksPhones(jwtToken?.jwtToken));
        }
        if (!campaignPermission?.skillGroupsIsBlock) {
            dispatch(getSkillGroupList(jwtToken?.jwtToken, true));
        }
        setActiveIndex(0)
    }, [
        dialogVisible,
        detailsLoading,
        companyStateSave,
        campaignId,
        campaignPermission?.usersIsBlock,
        campaignPermission?.skillGroupsIsBlock,
        campaignPermission?.trunksIsBlock,
    ])

    useEffect(() => {
        if (errorFields && errorFields?.nameUniq) {
            setActiveIndex(0);
        }
    }, [errorFields]);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const closeDialogVisible = () => {
        dispatch(setDialogVisible(false));
        setCreatedSchedule(false);
        dispatch(setCompanyStateSave(false));
        dispatch(setChangedCompaniesData(false));
        dispatch(setErrorFields(null));
    }

    const zeroSeconds = (dateStr: string): string => {
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) return dateStr;
        date.setSeconds(0);
        date.setMilliseconds(0);

        const pad = (n: number) => n.toString().padStart(2, '0');
        return `${pad(date.getMonth() + 1)}/${pad(date.getDate())}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}:00`;
    };

    const shouldTransformDates = !!companiesData.scheduler?.days;

    const normalizeCallCycles = (data: typeof companiesData) => {
        const {
            isCyclically: _isCyclically,
            isSequentiallyByCycle: _isSequentiallyByCycle,
            countCycles: _countCycles,
            ...campaignRest
        } = data?.campaign ?? {};

        const fallbackTotalCount = data?.callCycles?.[0]?.totalCount ?? 1;

        return {
            ...data,
            campaign: {
                ...campaignRest,
                callsDialerType: resolveCallsDialerType(data?.campaign) ?? CALLS_DIALER_TYPE.sequential,
            },
            callCycles: (data?.callCycles ?? []).map((c: any) => ({
                ...c,
                isFullCycle: c.isFullCycle ?? false,
                totalCount: c.totalCount ?? fallbackTotalCount
            }))
        };
    };

    const resolveSkillGroupName = (row: any) => {
        if (row?.name) {
            return row.name;
        }
        const sg = skillGroupList?.find(
            (s: any) =>
                s?.id != null &&
                row?.skillGroupId != null &&
                String(s.id) === String(row.skillGroupId)
        );
        return sg?.name || '';
    };

    const resolveAudioMeta = (audioId: any) => {
        const fromGroups = allAudioGroup?.find((a: any) => a.audioId === audioId);
        if (fromGroups) {
            return fromGroups;
        }
        return queuesDirectoryQueueAudioType?.find((a: any) => a.audioId === audioId);
    };

    const withCampaignGarbagePayload = (data: typeof companiesData) => {
        const cid = data?.campaign?.campaignId;
        const garbageStrategyOperators =
            data.campaign?.garbageStrategyOperators ??
            (data as { garbageStrategyOperators?: number }).garbageStrategyOperators ??
            308;
        const {garbageStrategyOperators: _legacyRoot, ...rest} = data as typeof companiesData & {
            garbageStrategyOperators?: number;
        };

        const campaignACD = data.campaignACD
            ? {
                ...data.campaignACD,
                ivmAudios: (data.campaignACD.ivmAudios ?? []).map((audio: any, index: number) => {
                    const meta = resolveAudioMeta(audio.audioId);
                    return {
                        ...audio,
                        audioId: audio.audioId,
                        order: audio.order ?? index + 1,
                        audioName: audio.audioName || meta?.audioName || '',
                        groupName: audio.groupName || meta?.groupName || '',
                        groupId: audio.groupId ?? meta?.groupId,
                    };
                }),
                mohAudioName:
                    data.campaignACD.mohAudioName ||
                    resolveAudioMeta(data.campaignACD.mohAudioId)?.audioName ||
                    '',
                mohAudioGroupName:
                    data.campaignACD.mohAudioGroupName ||
                    resolveAudioMeta(data.campaignACD.mohAudioId)?.groupName ||
                    '',
            }
            : data.campaignACD;

        return {
            ...rest,
            campaignACD,
            skillGroups: (data.skillGroups ?? []).map((g: any) => ({
                skillGroupId: g.skillGroupId,
                skillGroupLevel: g.skillGroupLevel ?? 0,
                campaignId: g.campaignId ?? cid,
                name: resolveSkillGroupName(g),
                isActive: g.isActive,
                isArchive: g.isArchive,
            })),
            skillGroupsGarbage: (data.skillGroupsGarbage ?? []).map((g: any) => ({
                skillGroupId: g.skillGroupId,
                displayOrder: g.displayOrder ?? g.skillGroupLevel,
                skillGroupLevel: g.displayOrder ?? g.skillGroupLevel,
                campaignId: g.campaignId ?? cid,
                name: resolveSkillGroupName(g),
                isActive: g.isActive,
                isArchive: g.isArchive,
            })),
            campaign: {
                ...data.campaign,
                garbageStrategyOperators,
            },
        };
    };

    const updateCampaign = (type: string) => {
        let companiesCopy = {...companiesData};

        // @ts-ignore
        companiesCopy.trunks = companies?.trunksPairs;

        const validationErrors = validate(companiesCopy);
        const cleanedCompaniesData = {
            ...companiesData,
            // @ts-ignore
            trunks: companies?.trunksPairs,
            scheduler: {
                ...companiesData.scheduler,
                days: shouldTransformDates
                    ? (companiesData.scheduler?.days ?? []).map((day: { start: string; end: string; }) => ({
                        ...day,
                        start: zeroSeconds(day.start),
                        end: zeroSeconds(day.end),
                    }))
                    : companiesData.scheduler?.days,
            },
        };

        const newCompaniesData = {
            ...companiesData,
            // @ts-ignore
            trunks: companies?.trunksPairs
        };
        if (!validationErrors) {
            const basePayload = normalizeCallCycles(shouldTransformDates ? cleanedCompaniesData : newCompaniesData);
            const payload = withCampaignGarbagePayload(basePayload);
            dispatch(updateCompanies(payload, jwtToken?.jwtToken));
            dispatch(setErrorFields(validationErrors));
            dispatch(setChangedCompaniesData(false));
            dispatch(setChangedScheduler(false));

            if (type === 'with_close') {
                closeDialogVisible();
            }
        } else {
            dispatch(setErrorFields(validationErrors));
            if (validationErrors.name || validationErrors.trankId || validationErrors.branchId || validationErrors.timeoutExternalOnAnswer) {
                setActiveIndex(0);
            } else if (validationErrors.ivmListeningTime || validationErrors.callCycles || validationErrors.countCycles) {
                setActiveIndex(4);
            } else if (validationErrors.startTime || validationErrors.startDate || validationErrors?.scheduler) {
                setActiveIndex(2);
            } else if (validationErrors.campaignUsers) {
                setActiveIndex(1);
            } else if (companiesData.campaign.campaignTypeId !== 205 &&( validationErrors.mohAudioTime || validationErrors.mohAudioId || validationErrors.mwtNoAgentAudioTime || validationErrors.mwtAudioTime || validationErrors.schedulerAudioTime || validationErrors.schedulerStrategyAction || validationErrors.mwtStrategyAction || validationErrors.mwtNoAgentStrategyAction || validationErrors.mwtNoAgent || validationErrors.mwt || validationErrors.mwtStrategy || validationErrors.mwtNoAgentStrategy || validationErrors.schedulerStrategy)) {
                setActiveIndex(5);
            } else if (validationErrors.ivmListeningTime || validationErrors.ivmAudios || validationErrors.audioRetries) {
                setActiveIndex(6);
            } else if ((validationErrors.mohAudioTime || validationErrors.mohAudioId) && companiesData.campaign.campaignTypeId === 205) {
                setActiveIndex(7);
            } else if (validationErrors.campaignAMD) {
                setActiveIndex(8);
            }
        }

        setCreatedSchedule(false);
    };

    const createCampaign = (type: string) => {
        let companiesCopy = {...companiesData};
        // @ts-ignore
        companiesCopy.trunks = companies?.trunksPairs;

        const validationErrors = validate(companiesCopy);

        const cleanedCompaniesData = {
            ...companiesData,
            // @ts-ignore
            trunks: companies?.trunksPairs,
            scheduler: {
                ...companiesData.scheduler,
                days: shouldTransformDates
                    ? (companiesData.scheduler?.days ?? []).map((day: { start: string; end: string; }) => ({
                        ...day,
                        start: zeroSeconds(day.start),
                        end: zeroSeconds(day.end),
                    }))
                    : companiesData.scheduler?.days,
            },
        };

        const newCompaniesData = {
            ...companiesData,
            // @ts-ignore
            trunks: companies?.trunksPairs
        };

        if (!validationErrors) {
            const basePayload = normalizeCallCycles(shouldTransformDates ? cleanedCompaniesData : newCompaniesData);
            const payload = withCampaignGarbagePayload(basePayload);
            dispatch(createCompanies(payload, jwtToken?.jwtToken));
            dispatch(setErrorFields(validationErrors));
            dispatch(setChangedScheduler(false));
            dispatch(setChangedCompaniesData(false));

            if (type === 'with_close') {
                closeDialogVisible();
            }
        } else {
            dispatch(setErrorFields(validationErrors));
            if (validationErrors.name || validationErrors.trankId || validationErrors.branchId || validationErrors.timeoutExternalOnAnswer) {
                setActiveIndex(0);
            } else if (validationErrors.ivmListeningTime || validationErrors.callCycles || validationErrors.countCycles) {
                setActiveIndex(4);
            } else if (validationErrors.startTime || validationErrors.startDate || validationErrors?.scheduler) {
                setActiveIndex(2);
            } else if (validationErrors.campaignUsers) {
                setActiveIndex(1);
            } else if (validationErrors.mohAudioTime || validationErrors.mohAudioId || validationErrors.mwtNoAgentAudioTime || validationErrors.mwtAudioTime || validationErrors.schedulerAudioTime || validationErrors.schedulerStrategyAction || validationErrors.mwtStrategyAction || validationErrors.mwtNoAgentStrategyAction || validationErrors.mwtNoAgent || validationErrors.mwt || validationErrors.mwtStrategy || validationErrors.mwtNoAgentStrategy || validationErrors.schedulerStrategy) {
                setActiveIndex(5);
            } else if (validationErrors.ivmAudios || validationErrors.audioRetries) {
                setActiveIndex(6);
            } else if ((validationErrors.mohAudioTime || validationErrors.mohAudioId) && companiesData.campaign.campaignTypeId === 205) {
                setActiveIndex(7);
            } else if (validationErrors.campaignAMD) {
                setActiveIndex(8);
            }
        }
        setCreatedSchedule(false);
    };
    const deleteCampaign = () => {
        if (jwtToken?.jwtToken) {
            dispatch(deleteCompanies(companiesData.campaign.campaignId, jwtToken?.jwtToken));
        }
        dispatch(setDialogVisible(false));
        dispatch(setCompanyStateSave(false))
        setCreatedSchedule(false);
    }

    const showDeletionNotification = () => {
        if (!deletionNotification && user.userId) {
            dispatch(getNotification(user.userId, 107, jwtToken?.jwtToken));
        }
        setShowDeleteNotification(true);
    }

    const showSaveChangesNotification = () => {
        if (changedCompaniesData) {
            if (!saveChangesNotification && user.userId) {
                dispatch(getNotification(user.userId, 113, jwtToken?.jwtToken));
            }
            setShowSaveChangeNotification(true);
        } else {
            dispatch(setDialogVisible(false));
            setCreatedSchedule(false);
            dispatch(setCompanyStateSave(false))
        }
    }

    const setActiveTabIndex = (e: any) => {
        if ((createdSchedule || changeScheduler) && activeIndex === 2) {
            setVisible(true);
            setSelectIndex(e.index);
        } else {
            setActiveIndex(e.index);
        }
    }

    const closeNotification = () => {
        setVisible(false);
        setActiveIndex(selectIndex);
        setCreatedSchedule(false);
        dispatch(setChangedScheduler(false));
    }

    const saveNewScheduler = () => {
        closeNotification();
    }

    const cancelSaveScheduler = () => {
        if (!companiesData.campaign.campaignId) {
            closeNotification();
            dispatch(resetScheduler());
            dispatch(setErrorFields(null))
        }
        if (companiesData.campaign.campaignId && !scheduler) {
            closeNotification()
            dispatch(setErrorFields(null))
            dispatch(resetScheduler());
        }
        if (companiesData.campaign.campaignId && scheduler) {
            closeNotification();
            dispatch(setErrorFields(null))
            dispatch(getCampaignId(selectedCompanyId, jwtToken?.jwtToken));
        }
    }

    const footer = (
        <div className="dialog-footer">
            <Divider/>
            <div className="buttons">
                {!companyStateSave && hasCampaignsDeletePermission && !props.isWindow && <Button icon={windowWidth > 1248 ? "pi pi-trash" : ''}
                                                                           className="p-button-outlined"
                                                                           label="Видалити"
                                                                           onClick={showDeletionNotification}
                />}
                <Button icon={windowWidth > 1248 ? "pi pi-ban" : ''}
                        className="p-button-outlined"
                        label="Відміна"
                        onClick={() => {
                            showSaveChangesNotification()
                        }}
                />
                {companyStateSave && hasCampaignsCreatePermission && <Button icon={windowWidth > 1248 ? "pi pi-save" : ''}
                                                                          className=""
                                                                          label="Створити та зберегти"
                                                                          onClick={() => {
                                                                              createCampaign('')
                                                                          }}
                />}
                {!companyStateSave && !statusDone && hasCampaignsUpdatePermission && <Button icon={windowWidth > 1248 ? "pi pi-save" : ''}
                                                                                          label="Зберегти"
                                                                                          onClick={() => {
                                                                                              updateCampaign('')
                                                                                          }}
                />}
            </div>
        </div>
    );

    return (
        <Dialog
            header="Налаштування кампанії"
            footer={archiveTableToggle ? footer : ''}
            visible={dialogVisible}
            dismissableMask={false}
            closeOnEscape={false}
            draggable={true}
            blockScroll={true}
            position="top"
            className='dialogInfo user-dialog-info'
            style={{width: '95vw', maxWidth: "1200px", minHeight: "80vh", zIndex: '1101px !important'}}
            onHide={() => showSaveChangesNotification()}
        >
            {companiesData && <div className="company-info-popup">
                <ConfirmDialog visible={showDeleteNotification} onHide={() => setShowDeleteNotification(false)} message={deletionMessage}
                               icon="pi pi-exclamation-triangle" acceptLabel="Продовжити" rejectLabel="Відмінити" accept={() => deleteCampaign()}/>
                {!companyStateSave && <ConfirmDialog visible={showSaveChangeNotification} onHide={() => setShowSaveChangeNotification(false)} message={saveChangeMessage}
                                                     icon="pi pi-exclamation-triangle" acceptLabel="Зберегти" rejectLabel="Відмінити" reject={() => closeDialogVisible()} accept={() => {
                    updateCampaign('with_close')
                }}/>}
                {companyStateSave && <ConfirmDialog visible={showSaveChangeNotification} onHide={() => setShowSaveChangeNotification(false)} message={saveChangeMessage}
                                                    icon="pi pi-exclamation-triangle" acceptLabel="Зберегти" rejectLabel="Відмінити" reject={() => closeDialogVisible()} accept={() => {
                    createCampaign('with_close')
                }}/>}
                <CompaniesListDialogInfo/>
                <Divider style={{margin: '0 0 20px 0'}}/>
                <CompaniesListDialogManagement/>
                <Divider style={{margin: '0 0 20px 0'}}/>
                <TabView className="user-dialog-info" activeIndex={activeIndex}
                         onTabChange={(e) => {
                             const leadsIndex =
                                 companiesData.campaign.campaignTypeId !== 204
                                     ? 3
                                     : 3

                             if (e.index === leadsIndex) {
                                if (campaignId) {
                                    const leadsUrl = `${window.location.origin}${window.location.pathname || ''}#/leads?campaignId=${campaignId}&childWindow=1`;
                                    window.open(leadsUrl, '_blank');
                                }
                                 return;
                             }

                             setActiveTabIndex(e);
                         }}
                >
                    <TabPanel header="Загальні налаштування">
                        {companiesData && <CompaniesListDialogGeneralSettings/>}
                    </TabPanel>
                    {companiesData.campaign.campaignTypeId !== 204 && <TabPanel header="Додати операторів">
                        <CompaniesListDialogUsers/>
                    </TabPanel>}
                    <TabPanel header="Запуск та завершення кампанії">
                        {hasCampaignsCreatePermission || hasCampaignsUpdatePermission ? <>{!createdSchedule && !companiesData.scheduler?.schedulerId && archiveTableToggle && !companiesData.scheduler?.typeScheduler && <Button onClick={() => {
                            setCreatedSchedule(true);
                            dispatch(setChangedCompaniesData(true));
                        }}>Створити розклад</Button>}</> : ''}
                        {(createdSchedule || companiesData.scheduler?.schedulerId || companiesData.scheduler?.days || companiesData.scheduler?.typeScheduler) && <CompaniesListDialogStartEndFinish createdSchedule={createdSchedule}></CompaniesListDialogStartEndFinish>}
                        {!companiesData.scheduler?.schedulerId && !archiveTableToggle && (
                            <div>Немає розкладу дзвінків</div>
                        )}
                    </TabPanel>
                    <TabPanel header="Ліди кампанії">
                    </TabPanel>
                    <TabPanel header="Цикл прозвону">
                        <CompaniesListRingCycle/>
                    </TabPanel>
                    {companiesData.campaign.campaignTypeId === 202 && <TabPanel header="Налаштування ACD">
                        <ACDSettingsTab/>
                    </TabPanel>}
                    {companiesData.campaign.campaignTypeId === 204 && <TabPanel header="Налаштування IVR">
                        <CampaignDialog_IVM_ACD/>
                    </TabPanel>}
                    {companiesData.campaign.campaignTypeId === 205 && <TabPanel header="Налаштування ACD">
                        <CampaignDialog_Progressive_advanced_ACD/>
                    </TabPanel>}
                    <TabPanel header="Налаштування AMD">
                        <CampaignDialogAMD/>
                    </TabPanel>
                </TabView>
            </div>}
            <Dialog visible={visible} style={{width: '25vw'}} onHide={() => setVisible(false)}>
                <p className="m-0">
                    Застосувати розклад запуску та завершення кампанії?
                </p>
                <div className="flex justify-content-end mt-4">
                    <Button className="mr-2" onClick={() => saveNewScheduler()}>Так</Button>
                    <Button className="p-button-outlined mr-2" onClick={() => cancelSaveScheduler()}>Ні</Button>
                    <Button className="p-button-outlined" onClick={() => setVisible(false)}>Відміна</Button>
                </div>
            </Dialog>
        </Dialog>
    )
}

export default CompaniesListDialog
